module.exports = __webpack_public_path__ + "img/hu.0d7409f8.svg";